import { Pipe, PipeTransform } from '@angular/core';
import {IFoodGroupIngredient} from '../../models/food-group';

@Pipe({
  name: 'hasAnyAllergicIngredient'
})
export class HasAnyAllergicIngredientPipe implements PipeTransform {

  transform(ingredients: Partial<IFoodGroupIngredient>[]): boolean {
    return ingredients.some((ingredient: IFoodGroupIngredient) => ingredient.isAllergic);
  }

}
